import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { marketingApi } from './services/api';
import { AccountProvider } from './contexts/AccountContext';
import { UserProvider } from './contexts/UserContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Auth0Wrapper from './components/Auth0Wrapper';
import AuthHandler from './components/AuthHandler';

// Components
import CampaignList from './components/CampaignList';
import CreateCampaign from './components/CreateCampaign';
import EmailTemplates from './components/EmailTemplates';
import Subscribers from './components/Subscribers';
import Analytics from './components/Analytics';
import Domains from './components/Domains';
import EmailAccounts from './components/EmailAccounts';
import Unibox from './components/Unibox';
import AWSAccountCreation from './components/AWSAccountCreation';
import IdentityHealthMonitoring from './components/IdentityHealthMonitoring';
import AccountRotationScheduling from './components/AccountRotationScheduling';
import CrossIdentityCampaignDistribution from './components/CrossIdentityCampaignDistribution';
import Profile from './components/Profile';
import UserManagement from './components/UserManagement';
import Sidebar from './components/Sidebar';
import Navigation from './components/Navigation';

// Redux store configuration
const store = configureStore({
  reducer: {
    [marketingApi.reducerPath]: marketingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(marketingApi.middleware),
});

function App() {
  return (
    <Provider store={store}>
      <Auth0Wrapper>
        <AccountProvider>
          <UserProvider>
            <ThemeProvider>
              <Router>
                <div className="App">
                  <AuthHandler />
                </div>
              </Router>
            </ThemeProvider>
          </UserProvider>
        </AccountProvider>
      </Auth0Wrapper>
    </Provider>
  );
}

export default App;